import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropboxbatch',
  templateUrl: './dropboxbatch.component.html',
  styleUrls: ['./dropboxbatch.component.css']
})
export class DropboxbatchComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }



  requestData = `
  {
    "paths": [
      "/videoimagemixfolder/bandtogether.mp4"
    ],
    "crunch_modes": [
      "video_optimizer"
    ],
    "process_type": "quality"
  }`


  Data = `
  }`




  sucessData = `
  {
    "data": null,
    "message": "Batch request submitted successfully"
  }
  `

  Error5x = `
  {
    "error": {},
    "message": "string"
  }
  `

  Error4x = `
  {
    "error": "crunch_modes is the required field and cannot be empty",
    "message": "Crunch Modes cannot be empty"
  }`

  Error42x = `
  {
    "error": "process_type is a required field when settings is ask me everytime",
    "message": "process_type is a required field"
  }`



  Error401x = `
  {
    "error": {},
    "message": "Unauthorized"
  }
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }




  // Image

  requestImageData = `
  curl 'https://api.optimusdrive.ai/v1/dropbox/batch' \ -H 'authorization: XXXX'  \ --data-raw  '{ 
    "paths": [ 
      "/videoimagemixfolder/vietnam-6634082_640.jpg" 
    ], 
    "crunch_modes": [ 
      "image_optimizer" 
    ] 
  }'
  `


  imageClipboard(){
    this.ImageopyToClipBoard(this.requestImageData);
  }


  ImageopyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }




}
